var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3579_3695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10.0001H16.2667C15.9026 9.9993 15.5481 10.1178 15.2577 10.3376C14.9672 10.5573 14.7567 10.8661 14.6584 11.2167L12.7001 18.1834C12.6875 18.2267 12.6611 18.2647 12.6251 18.2917C12.589 18.3188 12.5452 18.3334 12.5001 18.3334C12.455 18.3334 12.4111 18.3188 12.3751 18.2917C12.339 18.2647 12.3127 18.2267 12.3001 18.1834L7.70008 1.81675C7.68746 1.77347 7.66114 1.73546 7.62508 1.70841C7.58902 1.68137 7.54516 1.66675 7.50008 1.66675C7.455 1.66675 7.41114 1.68137 7.37508 1.70841C7.33902 1.73546 7.3127 1.77347 7.30008 1.81675L5.34175 8.78341C5.2438 9.13271 5.03457 9.44051 4.7458 9.66009C4.45704 9.87967 4.10451 9.99904 3.74175 10.0001H1.66675",
    stroke: "#00FFA3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3579_3695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSession);
export default __webpack_public_path__ + "static/media/session.1667d237de0ac221dc71eb55060ed0ef.svg";
export { ForwardRef as ReactComponent };